import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import StatCard from "./StatCard";
import UsersGrid from "./UsersGrid";
import UserFormModal from "./UserFormModal";
import { getAdminUsersApi, setFilteredChips, clearFilteredChips } from "../../../redux/features/adminUserSlice";
import { getMasterData } from "../../../services/userService";
import localStorageStore from "../../../utils/localStorageStore";
import { userRoleConstants } from "../../../utils/constants";


const Index = () => {
  const [showUserModal, setShowUserModal] = useState(false);
  const [userAllDetails, setUserAllDetails] = useState("");
  const [currentSize, setCurrentSize] = useState(10);
  const [masterData, setMasterData] = useState("");
  const [id, setId] = useState();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const filteredChips = useSelector((state) => state?.adminUser?.filteredChips);
  const {adminUserDetails, count} = useSelector((state) => state?.adminUser);

  const RoleId = parseInt(localStorageStore.getRole());
  const DistributorId = localStorage.getItem("distributorOrRetailerId");

  let page = 1;
  const { acc_no } = useParams();

  useEffect(() => {
    fetchMasterData(id ?? userAllDetails?.country_code);
    // eslint-disable-next-line
  }, [id, userAllDetails]);

  const fetchMasterData = async (countryCode) => {
    try {
      const response = await getMasterData(countryCode);
      setMasterData(response?.data);
    } catch (error) {
      console.error(error?.message);
    }
  };

  const handleChipRemove = (key) => {
    const updatedChips = filteredChips.filter(([existingKey]) => existingKey !== key);
    dispatch(setFilteredChips(updatedChips));

    let filteredData = Object.fromEntries(updatedChips);
    let transformedChips = {};
    for (let k in filteredData) {
      if (typeof filteredData[k] === "object" && "label" in filteredData[k] && "value" in filteredData[k]) {
        transformedChips[k] = filteredData[k].value;
      } else {
        transformedChips[k] = filteredData[k];
      }
    }
    dispatch(getAdminUsersApi({ filteredData: transformedChips, page, size: currentSize }));
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        let filteredData = {};

        if (acc_no) {
          filteredData = { user_id: DistributorId };
        } else if (
          RoleId === userRoleConstants.ADMIN_ID ||
          RoleId === userRoleConstants.MANAGER_ID ||
          RoleId === userRoleConstants.SUPERVISOR_ID
        ) {
          filteredData = {};
        } else {
          filteredData = { role_id: userRoleConstants.RETAILER_ID };
        }

        const response = await dispatch(getAdminUsersApi({ filteredData: filteredData, page, size: currentSize }));

        if (response?.meta?.requestStatus === "fulfilled") {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, acc_no]);


  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="pt-1 mb-1">Users</h4>
        <div>
          <button
            type="button"
            className="btn btn-sm btn-secondary rounded-pill waves-effect waves-light"
            onClick={() => setShowUserModal(true)}
          >
            <i className="ti ti-plus me-1"></i> Add
          </button>
        </div>
      </div>

      <StatCard totalAdminUsers={count} />
      <UsersGrid
        filteredChips={filteredChips}
        handleChipRemove={handleChipRemove}
        setCurrentSize={setCurrentSize}
        currentSize={currentSize}
        masterData={masterData}
        setId={setId}
        acc_no={acc_no}
        adminUserDetails={adminUserDetails}
        DistributorId={DistributorId}
        tebleLoading={loading}
        userAllDetails={userAllDetails}
        setUserAllDetails={setUserAllDetails}
      />
      {showUserModal && <UserFormModal show={showUserModal} setShow={setShowUserModal} masterData={masterData} setId={setId} currentSize={currentSize} />}
    </>
  );
};

export default Index;
